import { Fragment, useState } from 'react'
import { isDisabled, publishEvent, removeFileNamePrefix, fileUrl, configValue, getHookInfo } from '../../utils'
import FileClearButton from '../FileClearButton/FileClearButton'
import FileChooseButton from '../FileChooseButton/FileChooseButton'
import FileInput from '../FileInput/FileInput'
import FileLink from '../FileLink/FileLink'
import AlertModal from '../AlertModal/AlertModal'
import { CONFIG_KEYS } from '../../constants'
import allHooks from '../../hooks/allHooks'

export default function AppObjectFieldFile(props) {
  const { object, field, action, value, formInputs, handleChange, hasChanged } = props
  console.log('AppObjectFieldFile rendered: ', props)

  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)
  const [fileInfo, setFileInfo] = useState(initialFileInfo())
  const disabled = isDisabled(action, field.behaviorType)

  function initialFileInfo() {
    let serverFileName = null
    let serverUrl = null
    if (value) {
      serverFileName = value
      serverUrl = fileUrl(value)
    }
    return {
      serverFileName: serverFileName,
      serverUrl: serverUrl,
      localFileName: null,
      blobUrl: null,
    }
  }

  function handleFileChange(event) {
    console.log('*********************************** AppObjectFile.handleInputChange', event.target.files)
    if (event.target.files && event.target.files.length > 0) {
      let maxFileSize = configValue(CONFIG_KEYS.maxFileSize.key) ? configValue(CONFIG_KEYS.maxFileSize.key) : CONFIG_KEYS.maxFileSize.defaultValue
      maxFileSize = parseInt(maxFileSize) * 1024 * 1024
      console.log(`Max File Size: ${maxFileSize} File Size: ${event.target.files[0].size}`)
      if (event.target.files[0].size > maxFileSize) {
        toggle()
        return false
      }
    }

    const eventData = {
      objectId: object.id,
      fieldId: field.id,
      file: event.target.files[0],
      formInputs: formInputs,
    }
    publishEvent(`FILE SELECTED ${object.id}`, eventData, 'AppObjectFieldFile')
    let localFileName = event.target.value
    localFileName = removeFileNamePrefix(localFileName, '\\')
    handleChange(localFileName, hasChanged, field.id)
    let blobUrl = null
    if (event.target.files && event.target.files.length > 0) {
      blobUrl = URL.createObjectURL(event.target.files[0])
    }
    const newFileInfo = {
      serverFileName: null,
      serverUrl: null,
      localFileName: localFileName,
      blobUrl: blobUrl,
    }
    console.log(newFileInfo)
    setFileInfo(newFileInfo)
  }

  // file link is either a local, selected file (blobUrl) or a server file (serverFileName)
  let fileLink = null
  if (fileInfo.blobUrl) {
    fileLink = <a href={fileInfo.blobUrl} target="_blank" rel="noopener noreferrer">{fileInfo.localFileName}</a>
  } else if (fileInfo.serverFileName) {
    fileLink = <FileLink fileName={fileInfo.serverFileName} jwt={object.fileJwt} />
  }

  let fileInputControls = null
  if (!disabled) {
    // show "Clear" button for any file (local or server)
    let clearButton = null
    if (fileInfo.blobUrl || fileInfo.serverFileName) {
      clearButton = <FileClearButton handleInputChange={handleFileChange} />
    }

    // show either the browser "Choose File" or custom "Select File"
    if (field.largeChoiceHook) {
      const hookInfo = getHookInfo(field.largeChoiceHook)
      const selectFileButton = allHooks[hookInfo.moduleName][hookInfo.functionName](object, field, formInputs, handleChange, hasChanged, fileInfo, setFileInfo)
      fileInputControls = 
        <div style={{ paddingTop: '5px' }}>
          {selectFileButton}
          {clearButton}
        </div>
    } else {
      fileInputControls = 
      <Fragment>
        <FileInput fieldId={field.id} handleChange={handleFileChange} />
        <div style={{ paddingTop: '5px' }}>
          <FileChooseButton fieldId={field.id} buttonText={'Choose File'} />
          {clearButton}
        </div>
      </Fragment>
    }
  }

  if (disabled) {
    return fileLink
  } else {
    return (
      <div data-cy="app-object-field-file">
        <AlertModal modal={modal} toggle={toggle} />
        {fileLink}
        {fileInputControls}
      </div>
    )
  }
}
